import React from 'react';
import {
  SimpleGrid,
  Card,
  CardBody,
  Stat,
  StatLabel,
  StatNumber,
  Text,
  Spinner,
  Flex,
} from '@chakra-ui/react';
import { INotasAcompanhamentoTotalizadores } from '../../../../../../types/notasAcompanhamento';

interface NotasAcompKpiCardsProps {
  data?: INotasAcompanhamentoTotalizadores;
  isLoading?: boolean;
}

const formatNumber = (v?: number) => (v ?? 0).toLocaleString('pt-BR');

export function NotasAcompKpiCards({ data, isLoading }: NotasAcompKpiCardsProps) {
  if (isLoading && !data) {
    return (
      <Flex justify="center" py={4}>
        <Spinner color="primary" />
      </Flex>
    );
  }
  if (!data) return null;

  const totalNotas =
    (data.total_notas_entrada ?? 0) +
    (data.total_notas_saida ?? 0) +
    (data.total_notas_servico ?? 0);

  return (
    <SimpleGrid columns={{ base: 1, sm: 2, md: 3, xl: 6 }} spacing={3} mb={4}>
      <Card borderLeft="4px solid" borderLeftColor="#1976D2" bg="#E3F2FD">
        <CardBody p={4}>
          <Stat>
            <StatLabel fontSize="11px" color="gray.600" textTransform="uppercase" fontWeight="bold">
              Empresas c/ movimento
            </StatLabel>
            <StatNumber fontSize="22px" color="#1976D2">
              {formatNumber(data.total_empresas_com_movimento)}
            </StatNumber>
            <Text fontSize="11px" color="gray.600" mt={1}>
              Sem movimento: <strong>{formatNumber(data.total_empresas_sem_movimento)}</strong>
            </Text>
          </Stat>
        </CardBody>
      </Card>
      <Card borderLeft="4px solid" borderLeftColor="#5D7FFF" bg="#E8EFFF">
        <CardBody p={4}>
          <Stat>
            <StatLabel fontSize="11px" color="gray.600" textTransform="uppercase" fontWeight="bold">
              Notas no período
            </StatLabel>
            <StatNumber fontSize="22px" color="#5D7FFF">
              {formatNumber(totalNotas)}
            </StatNumber>
          </Stat>
        </CardBody>
      </Card>
      <Card borderLeft="4px solid" borderLeftColor="#2E7D32" bg="#E8F5E9">
        <CardBody p={4}>
          <Stat>
            <StatLabel fontSize="11px" color="gray.600" textTransform="uppercase" fontWeight="bold">
              Entradas
            </StatLabel>
            <StatNumber fontSize="22px" color="#2E7D32">
              {formatNumber(data.total_notas_entrada)}
            </StatNumber>
            <Text fontSize="11px" color="gray.600" mt={1}>
              Empresas: <strong>{formatNumber(data.total_empresas_movimento_entrada)}</strong>
            </Text>
          </Stat>
        </CardBody>
      </Card>
      <Card borderLeft="4px solid" borderLeftColor="#F57C00" bg="#FFF3E0">
        <CardBody p={4}>
          <Stat>
            <StatLabel fontSize="11px" color="gray.600" textTransform="uppercase" fontWeight="bold">
              Saídas
            </StatLabel>
            <StatNumber fontSize="22px" color="#F57C00">
              {formatNumber(data.total_notas_saida)}
            </StatNumber>
            <Text fontSize="11px" color="gray.600" mt={1}>
              Empresas: <strong>{formatNumber(data.total_empresas_movimento_saida)}</strong>
            </Text>
          </Stat>
        </CardBody>
      </Card>
      <Card borderLeft="4px solid" borderLeftColor="#9C27B0" bg="#F3E5F5">
        <CardBody p={4}>
          <Stat>
            <StatLabel fontSize="11px" color="gray.600" textTransform="uppercase" fontWeight="bold">
              Serviços
            </StatLabel>
            <StatNumber fontSize="22px" color="#9C27B0">
              {formatNumber(data.total_notas_servico)}
            </StatNumber>
            <Text fontSize="11px" color="gray.600" mt={1}>
              Empresas: <strong>{formatNumber(data.total_empresas_movimento_servico)}</strong>
            </Text>
          </Stat>
        </CardBody>
      </Card>
    </SimpleGrid>
  );
}
